import moment from 'moment';
import 'moment/locale/es';

/**
 * @typedef     {Object<string, any>} Repartidor
 * @property    {number} Id Identificador del repartidor
 * @property    {string} Nombre Nombre del repartidor
 * @property    {Orden[]} Ordenes Ordenes asignadas al repartidor
 * */


export const Constantes = {
    /**
    * @property {string[]} Tipos_Estatus Tipos de estado de la orden
    * */
    Tipos_Estatus: ["", "Ordenes Asignadas", "Sin Ordenes Asignadas", "En Ruta", "No Disponible"]
}

/**
 * @type    {Repartidor} Repartidor
 * */
export class Repartidor {

    /**
     * @property {number} Id Identificador del Repartidor
     * */
    Id = 0;
    /**
     * @property {string} Nombre Nombre del repartidor
     * */
    Nombre = "";
    /**
     * @property {Orden[]} Ordenes Lista de ordenes asignadas al repartidor
     * */
    Ordenes = [];
    /**
     * 
     * @property {string} Estatus Estado actual de la orden
     */
    Estatus = Constantes.Tipos_Estatus[0];
    /**
     * @property {boolean} Disponible Disponibilidad del repartidor
     * */
    Disponible = false;

    /**
     * @param {string} Nombre nombre del repartidor
     */
    constructor(Nombre, Disponible) {
        this.Nombre = Nombre;
        this.Disponible = Disponible;
        this.Estatus = Disponible ? Constantes.Tipos_Estatus[2] : Constantes.Tipos_Estatus[4];
    }

    /**
     * 
     * @param {number} Id Identificador del repartidor
     * @param {Orden[]} Ordenes Ordenes asignadas al repartidor
     */
    initAggregateProperties(Id) {
        this.Id = Id;
        // this.Estatus = Constantes.Tipos_Estatus[4];
    }

    /**
     * Inicializa las propiedades requeridas para acciones relacionadas
     * con la interfaz de usuario.
     * */
    initUIProperties() {
        this.UI = {};
        this.UI.selected = false;
    }


    /**
     * Genera nuevas instancias de Repartidor a partir
     * de respuesta del API.
     * 
     * @param {Object[]} data Arreglo de objetos a convertir a instancia de Repartidor
     * @returns {Repartidor[]} Arreglo de instancias de Repartidor.
     */
    static instanciate(data) {

        let items = Object.assign([], data);
        let instances = [];

        items.forEach(item => {


            let instance = new Repartidor(item.Nombre, item.Disponible);

            instance.initAggregateProperties(item.Id);
            instance.assignOrders([]);

            instance.initUIProperties();

            instances.push(instance);
        });

        return instances;
    }

    assignOrders(orders) { this.Ordenes = orders; this.updateStatus(); }

    assignOrder(Order) { this.Ordenes.push(Order); this.updateStatus(); }

    unassignOrder(Order) {
        this.Ordenes.splice(this.Ordenes.findIndex((orden) => orden.Id === Order.Id), 1);
        this.updateStatus();
    }

    updateStatus(status = null) {
        //  Se llam� sin par�metros
        if (status === null) {

            //  Tiene �rdenes asignadas
            if (this.Ordenes.length > 0) {
                let _OrdenesEnRuta = this.Ordenes.filter((orders, index) => orders.Estatus === Constantes.Tipos_Estatus[3] || orders.Estatus === "T").length;
                this.Estatus = _OrdenesEnRuta > 0 ? Constantes.Tipos_Estatus[3] : Constantes.Tipos_Estatus[1];
            } else {
                this.Estatus = Constantes.Tipos_Estatus[2];
            }
        } else {
            this.Estatus = status;
        }
    }

    static dummy(ammount) {
        let dummies = [];
        for (let i = 0; i < ammount; i++) {
            let dummy = new Repartidor("Dummy Repartidor");

            dummy.initAggregateProperties(i);
            //dummy.assignOrders(Orden.dummy(5));

            dummy.initUIProperties();

            dummies.push(dummy);
        }
        return dummies
    }
}

export class Entrega {
    /**
     * @property {string} Direccion direccion de la entrega
     * */
    Direccion = "Punto de Entrega";
    /**
     * @property {Object<string, any>} Coordenada coordenadas de la entrega
     * */
    Coordenada = { Latitud: 0, Longitud: 0 };

    /**
     * @param {string} Direccion Direccion de la entrega
     * @param {number} Latitud Latitud de la entrega
     * @param {number} Longitud Longitud de la entrega
     */
    constructor(Direccion, Latitud, Longitud) {
        this.Direccion = Direccion;
        this.Coordenada.Latitud = Latitud;
        this.Coordenada.Longitud = Longitud;
    }

    /**
     * @param {Object[]} data objetos a instanciar
     * @returns {Entrega[]} Instancias de Entrega
     */
    static instanciate(data) {
        let items = Object.assign([], data);
        let instances = [];

        items.forEach(item => {

            let instance = new Entrega(item.Direccion, Latitud, Longitud);

            instances.push(instance);
        });

        return instances;
    }

    /**
     * @param {number} ammount Cantidad de datos de prueba a generar
     * @returns {Entrega[]} Instancias de prueba de Entrega
     */
    static dummy(ammount) {
        let dummies = [];
        for (let i = 0; i < ammount; i++) {
            let dummy = new Entrega("Prueba", 9.991800, -84.233905);

            dummies.push(dummy);
        }
        return dummies
    }
}

export class Orden {
    //  =====   Propiedades     =====
    /**
     * @property {number} Id Identificador de Orden
     * */
    Id = 0;
    /**
     * @property {Date} Tiempo_Transcurrido Tiempo transcurrido de la orden
     * */
    Tiempo_Transcurrido = moment(new Date()).format("MM/DD/YYYY");
    /**
     * @property {Date} Fecha_Creacion  Fecha de creaci�n de la orden
     * */
    Fecha_Creacion = moment(new Date(), "MM/DD/YYYY");
    /**
     * @property {Object<string, any>} Monto Total de la orden
     * */
    Monto = { Moneda: "", Valor: 0.00 };
    /**
     * @property {string} Apoyo Tipo de apoyo de la orden
     * */
    Apoyo = "";
    /**
     * @property {Object<string, boolean>} Tipo_Pago Tipo de Pago de la orden
     * */
    Tipo_Pago = { Contado: false, Credito: false, Tipo: "" };
    /**
     * @property {Object<string, boolean>} Estatus Estatus de la orden
     * */
    Estatus = "";
    /**
     * @property {Entrega} Ruta Conjunto de Direcciones
     * */
    Ruta = null;
    /**
     * @property {Producto[]} Productos Productos de la orden
     * */
    Productos = []
    /**
     * @property {string} Tipo_Entrega Tipo de entrega de esta orden
     */
    Tipo_Entrega = ""
    /**
     * @property {number} Repartidor_Id ID del repartidor al que se asigno esta orden
     * */
    Repartidor_Id = 0

    Color = ""

    Pago = 0.00;

    Telefono = "";

    Cliente = "";

    Ubicacion_Direccion = "";

    Ubicacion_Localidad = "";

    Ubicacion_Referencia = "";

    Ubicacion_Nombre = "";

    Observaciones = "";

    Barrio = "";

    Direccion_Completa = "";

    Orden_Liquidada = false;

    Nivel1 = "";
    Nivel2 = "";
    Nivel3 = "";
    Nivel4 = "";
    Cambio = 0;

    Suc_Factura = 0;

    Ubicacion_Suc = {};

    ParControlRepartidorXSucursal = true;

    //  =====   Constructor     =====
    /**
     * @param {Date} Fecha_Creacion Fecha de creacion de Orden
     * @param {string} Estatus Estatus de la orden
     * @param {Object<any, string>} Monto Monto de la orden
     * @param {Producto[]} Productos Productos de la orden
     */
    constructor(Fecha_Creacion, Estatus, Monto, Productos) {
        var localLocale = moment('1993-10-23 00:00:00');
        moment.locale('es');
        localLocale.locale(false);


        this.Fecha_Creacion = moment(Fecha_Creacion).format("dddd D, MMMM, YYYY, hh:mm a");
        this.Estatus = Estatus;
        this.Monto = Monto;
        this.Productos = Productos;
    }

    /**
     * @param {number} Id Identificador de Orden
     * @param {Date} Tiempo_Transcurrido Timpo transcurrido de orden
     * @param {string} Apoyo Tipo de apoyo de orden
     * @param {Object} Tipo_Pago Tipo de pago de orden
     * @param {Entrega[]} Ruta Ruta de la orden
     * @param {Producto[]} Productos Productos de la orden
     */
    initAggregateProperties(
        Id, Color, Tiempo_Transcurrido, Apoyo, Tipo_Entrega, Tipo_Pago, Pago, Ruta, Productos,
        Telefono, Cliente, Ubicacion_Direccion, Ubicacion_Localidad, Observaciones, Barrio, Direccion_Completa, Orden_Liquidada, Nivel1, Nivel2, Nivel3, Nivel4,
        Ubicacion_Referencia, Ubicacion_Nombre, Cambio, Suc_Factura, Ubicacion_Suc, ParControlRepartidorXSucursal) {
        this.Id = Id;
        this.Color = Color;
        this.Tiempo_Transcurrido = moment(Tiempo_Transcurrido).format("dddd D, MMMM, YYYY, hh:mma");
        this.Apoyo = Apoyo;
        this.Tipo_Entrega = Tipo_Entrega;
        this.Tipo_Pago = Tipo_Pago;
        this.Pago = Pago;
        this.Ruta = Ruta;
        this.Productos = Productos;
        this.Telefono = Telefono;
        this.Cliente = Cliente;
        this.Ubicacion_Direccion = Ubicacion_Direccion;
        this.Barrio = Barrio;
        this.Ubicacion_Localidad = Ubicacion_Localidad;
        this.Ubicacion_Referencia = Ubicacion_Referencia;
        this.Observaciones = Observaciones;
        this.Direccion_Completa = Direccion_Completa;
        this.Orden_Liquidada = Orden_Liquidada;
        this.Nivel1 = Nivel1;
        this.Nivel2 = Nivel2;
        this.Nivel3 = Nivel3;
        this.Nivel4 = Nivel4;
        this.Ubicacion_Nombre = Ubicacion_Nombre;
        this.Cambio = Cambio;
        this.Suc_Factura = Suc_Factura;
        this.Ubicacion_Suc = Ubicacion_Suc;
        this.ParControlRepartidorXSucursal = ParControlRepartidorXSucursal;
    }

    /**
     * Inicializa las propiedades requeridas para acciones relacionadas
     * con la interfaz de usuario.
     * */
    initUIProperties() {
        this.UI = {};
        this.UI.selected = false;
    }

    /**
     * @deprecated
     * @param {any} ammount Cantidad de elementos a instanciar
     * @returns {Orden[]} Instancias de Orden
     */
    static dummy(ammount) {
        let dummies = []
        for (let i = 0; i < ammount; i++) {
            let dummyProducts = Producto.dummy(3);
            let dummy = new Orden(new Date(), Constantes.Tipos_Estatus[1], { Moneda: "C$", Valor: 100 }, dummyProducts);

            dummy.initAggregateProperties((Math.floor(Math.random() * 10000) + 1), new Date(), "PU", "", { Contado: true, Credito: false, Tipo: "" }, Entrega.dummy(1)[0], Producto.dummy(5))
            dummy.initUIProperties();

            dummies.push(dummy);
        }
        return dummies;
    }

    /**
    * Genera nuevas instancias de Orden a partir
    * de respuesta del API.
    *
    * @param {Object[]} data Arreglo de objetos a convertir a instancia de Orden
    * @returns {Orden[]} Arreglo de instancias de Orden.
    */
    static instanciate(data) {

        let items = Object.assign([], data);
        let instances = [];

        items.forEach(item => {

            let instance = new Orden(item.Fecha_Registro, item.Estatus_Id, { Moneda: item.Moneda, Valor: item.Total }, Producto.dummy(4));


            let tipoPagoInstancia = { Contado: false, Credito: false, Tipo: item.Tipo_Pago };

            switch (item.Tipo_Pago) {
                case "CR":
                    tipoPagoInstancia.Credito = true;
                    tipoPagoInstancia.Contado = false;
                    break;
                case "CO":
                    tipoPagoInstancia.Contado = true;
                    tipoPagoInstancia.Credito = false;
                    break;
                case "RE":
                    tipoPagoInstancia.Contado = false;
                    tipoPagoInstancia.Credito = false;

            }

            tipoPagoInstancia.Tipo = item.Tipo_Pago;
            instance.initAggregateProperties(
                item.Id, item.Color, item.Fecha_Registro, item.Apoyo, item.Tipo_Entrega,
                tipoPagoInstancia, parseFloat(item.Pago),
                new Entrega(item.Ubicacion.Direccion, parseFloat(item.Ubicacion.Latitud), parseFloat(item.Ubicacion.Longitud)), [],
                item.Telefono, item.Cliente, item.Ubicacion_Direccion, item.Ubicacion_Localidad, item.Observaciones, item.Barrio,
                item.Direccion_Completa, item.Orden_Liquidada, item.Ubicacion.Nivel1, item.Ubicacion.Nivel2, item.Ubicacion.Nivel3, item.Ubicacion.Nivel4, item.Ubicacion_Referencia, item.Ubicacion.Nombre,
                item.Cambio, item.Suc_Factura, item.Ubicacion_Suc, item.ParControlRepartidorXSucursal
            );
            instance.Repartidor_Id = item.Repartidor_Id;
            instance.initUIProperties();

            instances.push(instance);
        });

        return instances;
    }
}

export class Producto {

    /**
     * @property {number} Id Identificador de producto
     * */
    Id = 0;
    /**
     * @property {string} Nombre Nombre del producto
     */
    Nombre = "";
    /**
     * @property {number} Precio Precio del producto
     */
    Precio = "";
    /**
     * @property {string} Imagen Imagen del producto
     */
    Imagen = "";

    /**
     * @param {string} Nombre nombre del producto
     * @param {number} Precio Precio del producto
     * @param {string} Imagen Imagen del producto
     */
    constructor(Nombre, Precio, Imagen) {
        this.Nombre = Nombre;
        this.Precio = Precio;
        this.Imagen = Imagen;
    }

    /**
     * @param {number} Id Identificador del producto
     */
    initAggregateProperties(Id) {
        this.Id = Id;
    }

    /**
     * Inicializa las propiedades requeridas para acciones relacionadas
     * con la interfaz de usuario.
     * */
    initUIProperties() {
        this.UI = {};
        this.UI.selected = false;
    }


    /**
     * Genera nuevas instancias de Producto a partir
     * de respuesta del API.
     * 
     * @param {Object[]} data Arreglo de objetos a convertir a instancia de Producto
     * @returns {Producto[]} Arreglo de instancias de Producto.
     */
    static instanciate(data) {
        let items = Object.assign([], data);
        let instances = [];

        items.forEach(item => {

            let instance = new Producto(item.Nombre, item.Precio, item.Imagen);

            instance.initAggregateProperties(item.Id);
            instance.initUIProperties();

            instances.push(instance);
        });

        return instances;
    }

    /**
     * Devuelve un arreglo de objetos de prueba de esta clase.
     * @deprecated
     * @param {number} ammount Cantidad de objetos de prueba
     * @returns {Repartidor[]} array of objects
     */
    static dummy(ammount) {
        let dummies = []
        for (let i = 0; i < ammount; i++) {
            let dummy = new Producto("Dummy", "100", "imagen.jpg");

            dummy.initAggregateProperties(i);
            dummy.initUIProperties();

            dummies.push(dummy);
        }
        return dummies
    }
}

/**
 * @typedef {Object} Infobox
 * */
class Infobox { }

class PushPin { }

class Direction { }

export class BingMap {
    /**
     * @property {number[]} center Centro del mapa a mostrarse de forma predeterminada.
     * */
    center = [9.974848, -84.1938];

    /**
     * @property {Infobox[]} infoboxes Lista de carteles a mostrar en el mapa de Bing
     * */
    infoboxes = []

    /**
     * @property {Direction[]} directions Ruta a mostrar en el mapa
     * */
    directions = []
}